import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { useCountUp } from '../hooks/useCountUp';
export function StatsBar() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.3
  });
  return <section ref={ref} className="w-full bg-brand-primary py-8 md:py-12" data-id="element-618">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-619">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-0" data-id="element-620">
          <StatItem value={500} prefix="+" label="Vehículos Rastreados" isVisible={isVisible} hasBorder data-id="element-621" />
          <StatItem value={24} suffix="/7" label="Monitoreo Activo" isVisible={isVisible} hasBorder data-id="element-622" />
          <StatItem value={3} label="Marcas GPS Líderes" isVisible={isVisible} hasBorder data-id="element-623" />
          <StatItem value={98} suffix="%" label="Satisfacción de Clientes" isVisible={isVisible} data-id="element-624" />
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  prefix = '',
  suffix = '',
  label,
  isVisible,
  hasBorder = false
}: {
  value: number;
  prefix?: string;
  suffix?: string;
  label: string;
  isVisible: boolean;
  hasBorder?: boolean;
}) {
  const count = useCountUp(value, isVisible);
  return <div className={`text-center px-4 md:px-8 ${hasBorder ? 'md:border-r md:border-cyan-subtle' : ''}`} data-id="element-625">
      <p className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-2" data-id="element-626">
        {prefix}
        {count}
        {suffix}
      </p>
      <p className="font-subheading text-sm md:text-base text-brand-text-secondary" data-id="element-627">
        {label}
      </p>
    </div>;
}